/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useRef, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import DeleteModal from 'src/components/modal/DeleteModal';
import { useNavigate } from 'react-router-dom';
import OrderServiceListResults from 'src/components/order/OrderServicesListResult';
import {
  Trash2 as TrashIcon,
  Save as SaveIcon,
  PlusCircle as PlusIcon,
  Check as ChekIcon,
} from 'react-feather';
import moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import ServiceModal from '../modal/ServiceModal';
import CancelOrderModal from '../modal/CancelOrderModal';
import ConfirmModal from '../modal/ConfirmModal';
import CreatePDF from './CreatePDF';

const OrderProfileDetails = (props) => {
  const myRef = useRef();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const toDay = new Date();
  const [clientsSearch, setClientsSearch] = useState([]);

  // NOVOS ESTADOS PARA MULTIPLO UPLOAD DE IMAGENS
  const [serviceImages, setServiceImages] = useState([]);
  const [finalizedImages, setFinalizedImages] = useState([]);
  const [entryImages, setEntryImages] = useState([]);
  const [productsSearch, setProductsSearch] = useState([]);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [clientValidate, setClientValidate] = useState({
    client_id: null,
    error: ''
  });
  const [productValidate, setProductValidate] = useState('');

  const handleServiceFilesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setServiceImages((prev) => [...prev, ...files]);
    }
  };

  const handleFinalizedFilesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setFinalizedImages((prev) => [...prev, ...files]);
    }
  };

  const handleRemoveServiceImage = (indexToRemove) => {
    setServiceImages((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleRemoveFinalizedImage = (indexToRemove) => {
    setFinalizedImages((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const handleEntryFilesChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      setEntryImages((prev) => [...prev, ...files]);
    }
  };

  const handleRemoveEntryImage = (indexToRemove) => {
    setEntryImages((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  const scrollTop = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const formatDate = (value) => {
    if (value) {
      return moment.parseZone(value).format('YYYY-MM-DDTHH:mm');
    }
    return value;
  };

  const [deleteImageModal, setDeleteImageModal] = useState({
    open: false,
    id: null,
    text: '',
    cancel: () => {},
    confirm: () => {}
  });

  const [values, setValues] = useState({
    product_id: '',
    order_number: '',
    productObject: null,
    authorization_withdrawal: '',
    technician_id: '',
    status: '',
    entry_date: formatDate(toDay),
    approved_budget_date: '',
    canceled_order_date: '',
    finalized_budget_date: '',
    finished_order_date: '',
    running_service_date: '',
    service_completed_date: '',
    awaiting_withdrawal_date: '',
    reason_canceled: '',
    observation: '',
  });

  const [serviceModal, setServiceModal] = useState({
    open: false,
    service: null,
    order_id: null,
    title: 'Cadastrar serviços',
  });

  const [cancelOrderModal, setCancelOrderModal] = useState({
    open: false,
    service: null,
    order_id: null,
    title: 'Cadastrar serviços',
  });

  const [confirmOrderModal, setConfirmOrderModal] = useState({
    open: false,
    title: '',
    descriotion: '',
  });

  const {
    config,
    productId,
    products,
    product,
    status,
    order,
    saveform,
    updateform,
    deleteImage,
    technicians,
    deleteService,
    reload,
    getService,
    saveService,
    updateService,
    setChangeStatusOrder,
    setCancel,
    clients,
    getProduct,
    getProductsByClient,
  } = props;

  useEffect(() => {
    setDisabled(false);
  }, []);

  useEffect(() => {
    if (clients && clients.data) {
      setClientsSearch(clients.data);
    }
  }, [clients]);

  useEffect(() => {
    if (products && products.data) {
      setProductsSearch(products.data);
    }
  }, [products]);

  useEffect(() => {
    if (order) {
      setCurrentProduct(order.product);
      setValues({
        product_id: order.product.id || null,
        authorization_withdrawal: order.authorization_withdrawal,
        technician_id: order.technician ? order.technician.id : null,
        status: order.status,
        order_number: order.order_number,
        execute_date: order.execute_date || null,
        entry_date: order.entry_date ? formatDate(order.entry_date) : '',
        awaiting_withdrawal_date: order.awaiting_withdrawal_date ? formatDate(order.awaiting_withdrawal_date) : null,
        approved_budget_date: order.approved_budget_date ? formatDate(order.approved_budget_date) : null,
        finalized_budget_date: order.finalized_budget_date ? formatDate(order.finalized_budget_date) : null,
        canceled_order_date: order.canceled_order_date ? formatDate(order.canceled_order_date) : null,
        finished_order_date: order.finished_order_date ? formatDate(order.finished_order_date) : null,
        running_service_date: order.running_service_date ? formatDate(order.running_service_date) : null,
        service_completed_date: order.service_completed_date ? formatDate(order.service_completed_date) : null,
        labor: order.labor || 0,
        amount_order: order.amount_order || 0,
        paid_out: order.paid_out || false,
        amount_services: order.amount_services || 0,
        amount_aproved_services: order.amount_aproved_services || 0,
        observation: order.observation || '',
        diagnosis: order.diagnosis || '',
        reason_canceled: order.reason_canceled || '',
      });
      if (order.status === 'C' || order.status === 'F') {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    } else {
      setValues({
        status: 'WB',
        product_id: '',
        productObject: null,
        authorization_withdrawal: '',
        technician_id: '',
        entry_date: formatDate(toDay),
        reason_canceled: '',
        observation: '',
        diagnosis: '',
      });
    }
  }, [order]);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value.toUpperCase()
    });
  };

  // eslint-disable-next-line consistent-return
  const validateFields = () => {
    if (productId) {
      return true;
    }
    let isValid = true;
    if (!clientValidate.client_id) {
      setClientValidate({
        ...clientValidate,
        error: 'Selecione o Cliente da Ordem'
      });
      scrollTop();
      isValid = false;
    } else {
      setClientValidate({
        ...clientValidate,
        error: ''
      });
    }

    if (!values.product_id) {
      setProductValidate('Selecione o Produto da Ordem');
      isValid = false;
      scrollTop();
    } else {
      setProductValidate('');
    }

    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Faz a formatação padrão do dinheiro que você já tinha
    const laborFormatted = values.labor !== 0 && values.labor
      ? values.labor.replace('R$', '').replace(',', '!').replace('.', '').replace('!', '.')
      : 0;

    // 2. Instancia o FormData que vai carregar os textos e os arquivos binários
    const formData = new FormData();

    // 3. Mapeia e insere todos os campos de texto comuns dentro do FormData
    Object.keys(values).forEach((key) => {
    // Pula o campo labor original, pois vamos colocar o formatado abaixo
      if (key !== 'labor' && values[key] !== null && values[key] !== undefined) {
        formData.append(key, values[key]);
      }
    });

    // Insere o valor do labor corrigido
    formData.append('labor', laborFormatted);

    // 4. ANEXA OS ARRAYS DE IMAGENS DO SERVIÇO (se houverem)
    if (serviceImages && serviceImages.length > 0) {
      serviceImages.forEach((file) => {
        formData.append('service_images[]', file);
      });
    }

    // 5. ANEXA OS ARRAYS DE IMAGENS DO PRODUTO FINALIZADO (se houverem)
    if (finalizedImages && finalizedImages.length > 0) {
      finalizedImages.forEach((file) => {
        formData.append('finalized_images[]', file);
      });
    }

    if (entryImages && entryImages.length > 0) {
      entryImages.forEach((file) => {
        formData.append('entry_images[]', file);
      });
    }

    // 6. ENVIANDO PARA O BACKEND
    if (order) {
    // Na Edição/Atualização
    // DICA: O Laravel às vezes exige que requisições multipart/form-data sejam enviadas como POST simulando PUT.
    // Se o seu updateform falhar, certifique-se de adicionar a linha abaixo:
      const updated = await updateform(order.id, formData);

      if (updated) {
        // Limpa os estados locais após salvar com sucesso
        setServiceImages([]);
        setFinalizedImages([]);
        setEntryImages([]);

        // Redireciona apenas se a atualização deu certo no banco
        navigate('/app/orders', { replace: true });
      }
    } else {
    // Na Criação (Nova Ordem Rápida)
      const valid = validateFields();
      if (valid) {
        const save = await saveform(formData);
        if (save) {
          navigate('/app/orders', { replace: true });
        }
      }
    }
  };

  const handleSeeClient = () => {
    navigate(`/app/client/${order.client.id}`, { replace: true });
  };

  const handleClientItemSelecionado = async (event, clientChange) => {
    if (clientChange) {
      setClientValidate({
        error: '',
        client_id: clientChange.id,
      });
      await getProductsByClient(clientChange.id);
    } else {
      setProductsSearch([]);
    }
  };

  const handleProductItemSelecionado = async (event, productChange) => {
    if (productChange) {
      setValues({
        ...values,
        product_id: productChange.id,
        productObject: productChange
      });
      setProductValidate('');
    } else {
      setValues({
        ...values,
        product_id: null,
        productObject: null
      });
    }
  };

  const reloadData = async () => {
    await reload(order.id);
  };

  const deleteOrderImage = (id, imageKey) => {
    setDeleteImageModal({
      open: true,
      id,
      text: 'Deseja realmente excluir esta imagem da ordem de serviço?',
      cancel: () => setDeleteImageModal((prev) => ({ ...prev, open: false })),
      confirm: async (imageId) => {
        try {
          console.log(`Confirmado! Tentando deletar a imagem com ID ${imageId} e chave ${imageKey}`);

          // 1. Executa a deleção no servidor via API
          const result = await deleteImage(imageId);

          // 2. Se a deleção no banco deu certo, atualiza a lista e fecha o modal
          if (result) {
            await reloadData();
          }
        } catch (error) {
          console.error('Erro ao deletar a imagem:', error);
        } finally {
          // Garante que o modal feche após finalizar o processo
          setDeleteImageModal((prev) => ({ ...prev, open: false }));
        }
      }
    });
  };

  const confirmModalService = async (data) => {
    if (data.id) {
      await updateService(data.id, data);
    } else {
      await saveService(data);
    }
    await reloadData();
    setServiceModal({ open: false });
  };

  const addService = () => {
    setServiceModal(
      {
        ...serviceModal,
        open: true,
        title: 'Cadastrar serviços',
        service: null,
        order_id: order.id,
        cancel: () => { },
        confirm: (data) => { confirmModalService(data); }
      }
    );
  };

  const editService = async (id) => {
    const service = await getService(id);
    if (service) {
      setServiceModal(
        {
          ...serviceModal,
          disabled,
          service,
          title: 'Editar serviços',
          open: true,
          order_id: order.id,
          cancel: () => { },
          confirm: (data) => { confirmModalService(data); }
        }
      );
    }
  };

  const confirmCancelOrderModal = async (data) => {
    const dataUpdate = {
      ...values,
      reason_canceled: data.reason_canceled,
      status: 'C'
    };
    await setCancel(order.id, dataUpdate);
    setCancelOrderModal({
      open: false
    });
  };

  const cancelModal = () => {
    setCancelOrderModal(
      {
        open: true,
        cancel: () => { },
        confirm: (data) => { confirmCancelOrderModal(data); }
      }
    );
  };

  const confirmModalStatus = async (statusOrder) => {
    await setChangeStatusOrder(order.id, statusOrder);
    setConfirmOrderModal({
      open: false
    });
  };

  const generatePDF = () => {
    const data = order;
    console.log('Gerando PDF com os seguintes dados da ordem:', data);
    data.image = config.image;
    data.enterprise = config.name;
    data.document = config.document;
    data.email = config.email;
    data.phone = config.phone;
    CreatePDF(data);
  };

  // eslint-disable-next-line no-shadow
  const confirmModal = (status) => {
    let title;
    let description;

    switch (status) {
      case 'SC':
        title = 'Marcar como Serviço Finalizado';
        description = 'Deseja colocar esta order como status Serviços Finalizados assim como todos os seus serviços aprovados ?';
        break;
      case 'FO':
        title = 'Marcar como Order Finalizada';
        description = 'Deseja colocar esta order como status Order Finalizado assim como todos os seus serviços aprovados ?';
        break;
      case 'AW':
        title = 'Marcar como Aguardando Retirada';
        description = 'Deseja colocar esta order como status Aguardando Retirada do Cliente e finalizar todos os serviços aprovados ?';
        break;

      default:
        break;
    }

    setConfirmOrderModal(
      {
        open: true,
        title,
        description,
        cancel: () => { },
        // eslint-disable-next-line no-unused-expressions
        confirm: () => { confirmModalStatus(status); }
      }
    );
  };

  useEffect(() => {
    const fetchProduct = async () => {
      if (productId) {
        await getProduct(productId);
        setValues((prevValues) => ({
          ...prevValues,
          product_id: productId
        }));
      }
    };
    fetchProduct();
  }, []);

  // eslint-disable-next-line consistent-return
  const bottonsFunction = () => {
    if (order) {
      if (order.status === 'AB' || order.status === 'RS') {
        return (
          <>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="error"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={cancelModal}
              >
                <TrashIcon style={{ marginRight: 10 }} />
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="info"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={() => { confirmModal('SC'); }}
              >
                <ChekIcon style={{ marginRight: 10 }} />
                Finalizar Serviços
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="success"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                style={{ color: '#fff' }}
                onClick={() => { confirmModal('FO'); }}
              >
                Finalizar Ordem
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Button
                color="success"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={generatePDF}
              >
                Imprimir
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="primary"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="submit"
              >
                <SaveIcon style={{ marginRight: 10 }} />
                Salvar
              </Button>
            </Grid>
          </>
        );
      }

      if (order.status === 'SC') {
        return (
          <>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="error"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={cancelModal}
              >
                <TrashIcon style={{ marginRight: 10 }} />
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="info"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={() => { confirmModal('AW'); }}
              >
                <ChekIcon style={{ marginRight: 10 }} />
                Aguardando Retirada do Cliente
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="primary"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="submit"
              >
                <SaveIcon style={{ marginRight: 10 }} />
                Salvar
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3} p={1}>
              <Button
                color="success"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={generatePDF}
              >
                Imprimir
              </Button>
            </Grid>
          </>
        );
      }

      if (order.status === 'AW') {
        return (
          <>
            <Grid item xs={12} lg={3} md={3}>
              <Button
                color="error"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={cancelModal}
              >
                <TrashIcon style={{ marginRight: 10 }} />
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Button
                color="info"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={() => { confirmModal('FO'); }}
              >
                <ChekIcon style={{ marginRight: 10 }} />
                Finalizar Order
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Button
                color="success"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="button"
                onClick={generatePDF}
              >
                Imprimir
              </Button>
            </Grid>
            <Grid item xs={12} lg={3} md={3}>
              <Button
                color="primary"
                sx={{ width: { xs: '100%', md: 'auto' } }}
                variant="contained"
                type="submit"
              >
                <SaveIcon style={{ marginRight: 10 }} />
                Salvar
              </Button>
            </Grid>

          </>
        );
      }

      if (order.status === 'CO' || order.status === 'FO') {
        return (
          <>
          </>
        );
      }

      return (
        <>
          <Grid item xs={12} lg={3} md={3}>
            <Button
              color="success"
              sx={{ width: { xs: '100%', md: 'auto' } }}
              variant="contained"
              type="button"
              onClick={generatePDF}
            >
              Imprimir
            </Button>
          </Grid>
          <Grid item xs={12} lg={2} md={2} p={1}>
            <Button
              color="primary"
              sx={{ width: { xs: '100%', md: 'auto' } }}
              variant="contained"
              type="submit"
            >
              <SaveIcon style={{ marginRight: 10 }} />
              Salvar
            </Button>
          </Grid>
        </>
      );
    }
    return (
      <Grid item xs={12} lg={2} md={2} p={1}>
        <Button
          color="primary"
          sx={{ width: { xs: '100%', md: 'auto' } }}
          variant="contained"
          type="submit"
          onClick={generatePDF}
        >
          <SaveIcon style={{ marginRight: 10 }} />
          Salvar
        </Button>
      </Grid>
    );
  };

  const productOrder = () => {
    if (currentProduct) {
      return (
        <Card sx={{ mb: 3 }}>
          <CardHeader title=" Produto da Ordem" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6} md={6}>
                <Box
                  component="img"
                  alt={currentProduct.name}
                  src={currentProduct.image ? currentProduct.image : '/image/no-image.png'}
                  title={currentProduct.name}
                  sx={{
                    maxHeight: 140,
                    width: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={6} md={6}>
                <Typography variant="h4" sx={{ mb: 1 }}>
                  {currentProduct.name}
                </Typography>
                <Typography variant="h5" sx={{ mb: 1 }}>
                  {`${currentProduct.brand} / ${currentProduct.model}`}
                </Typography>
                <Typography variant="h5">
                  {currentProduct.tension}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      );
    }
  };

  return (
    <form
      ref={myRef}
      autoComplete="off"
      onSubmit={handleSubmit}
      {...props}
    >
      {order && (
      <Typography variant="h2" p={2}>
        {' '}
        Numero da Ordem :
        {' '}
        {order.order_number}
      </Typography>
      )}
      {order && order.client.deleted
         && (
         <>
           <Box sx={{
             mb: 2, bgcolor: 'error.light', p: 2, borderRadius: 1
           }}
           >
             <Typography color="error.dark">Não é possível continuar com esta ordem até que o produto tenha um cliente, adicione um cliente ao produto ou cancele a ordem</Typography>
           </Box>
           <Box sx={{
             mb: 2, bgcolor: 'info.light', p: 2, borderRadius: 1
           }}
           >
             <Typography color="info.dark">
               Para editar o produto
               <Button onClick={() => { navigate(`/app/product/${order.product.id}`, { replace: true }); }}> Clique Aqui</Button>
             </Typography>
           </Box>
         </>
         )}

      {productOrder()}
      <Card>
        <CardHeader
          title="Orderm de Serviço"
        />
        <Divider />

        {/* ================= SEÇÃO DE IMAGENS EM GRUPOS E COLLAPSE ================= */}
        <Box sx={{ p: 3 }}>
          <Typography variant="h4" sx={{ mb: 2 }}>Galeria de Fotos da Ordem</Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              {/* 1. Imagens de Entrada do Produto (Vindo do Resource - Apenas Leitura/Exibição) */}
              <Accordion
                sx={{
                  boxShadow: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  mb: 1
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 'bold' }}>Imagens de Entrada do Produto</Typography>
                </AccordionSummary>
                <AccordionDetails>

                  {/* Subseção: Fotos já existentes no banco de dados */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Imagens Salvas no Histórico (Check-in)
                  </Typography>
                  {order && order.images_entry && order.images_entry.length > 0 ? (
                    <List sx={{
                      bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #eee', mb: 2
                    }}
                    >
                      {order.images_entry.map((img, idx) => (
                        <ListItem
                          key={`saved-entry-img-${img.id || idx}`}
                          secondaryAction={!disabled && (
                          <IconButton
                            edge="end"
                            onClick={() => deleteOrderImage(img.id, `saved-entry-img-${img.id || idx}`)} // Função para apagar do servidor
                            title="Apagar imagem do servidor"
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar
                              variant="square"
                              src={img.url || img.image}
                              sx={{ width: 50, height: 50, cursor: 'pointer' }}
                              onClick={() => window.open(img.url || img.image, '_blank')}
                            />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary="Imagem de Entrada" secondary="Salva no servidor" />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                      Nenhuma imagem salva para este estágio até o momento.
                    </Typography>
                  )}

                  <Divider sx={{ my: 2 }} />

                  {/* Subseção: Envio de novos arquivos para a entrada */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Enviar Novas Fotos de Entrada
                  </Typography>

                  {!disabled && (
                  <Button component="label" variant="contained" color="primary" sx={{ mb: 2 }}>
                    Selecionar Fotos de Entrada
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      hidden
                      onChange={handleEntryFilesChange}
                    />
                  </Button>
                  )}

                  {entryImages && entryImages.length > 0 ? (
                    <List sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #ddd' }}>
                      {entryImages.map((file, index) => (
                        <ListItem
                          key={`upload-entry-img-${file.name}-${file.size}`}
                          secondaryAction={!disabled && (
                          <IconButton edge="end" onClick={() => handleRemoveEntryImage(index)}>
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar variant="square" src={URL.createObjectURL(file)} sx={{ width: 50, height: 50 }} />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB (Aguardando Salvar)`} />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary">Nenhuma nova foto na fila de upload de entrada.</Typography>
                  )}
                </AccordionDetails>
              </Accordion>

              {/* 2. Adicionar / Gerenciar Imagens do Serviço (stage: 'analysis') */}
              <Accordion
                sx={{
                  boxShadow: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  mb: 1
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 'bold' }}>Imagens do Andamento do Serviço</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* Subseção: Fotos já existentes no banco de dados */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Imagens Salvas no Histórico
                  </Typography>
                  {order && order.images_service && order.images_service.length > 0 ? (
                    <List sx={{
                      bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #eee', mb: 2
                    }}
                    >
                      {order.images_service.map((img) => (
                        <ListItem
                          key={`saved-service-img-${img.id}`}
                          secondaryAction={!disabled && (
                          <IconButton
                            edge="end"
                            onClick={() => deleteOrderImage(img.id, `saved-service-img-${img.id}`)}
                            title="Apagar imagem do servidor"
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar
                              variant="square"
                              src={img.image}
                              sx={{ width: 50, height: 50, cursor: 'pointer' }}
                              onClick={() => window.open(img.image, '_blank')}
                            />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary="Imagem registrada" secondary="Salva no servidor" />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2, italic: 'true' }}>
                      Nenhuma imagem salva para este estágio até o momento.
                    </Typography>
                  )}

                  <Divider sx={{ my: 2 }} />

                  {/* Subseção: Envio de novos arquivos */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Enviar Novas Fotos para o Serviço
                  </Typography>

                  {!disabled && (
                  <Button component="label" variant="contained" color="primary" sx={{ mb: 2 }}>
                    Selecionar Fotos do Serviço
                    <input type="file" accept="image/*" multiple hidden onChange={handleServiceFilesChange} />
                  </Button>
                  )}

                  {serviceImages.length > 0 ? (
                    <List sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #ddd' }}>
                      {serviceImages.map((file, index) => (
                        <ListItem
                          key={`upload-service-img-${file.name}-${file.size}`}
                          secondaryAction={!disabled && (
                          <IconButton edge="end" onClick={() => handleRemoveServiceImage(index)}>
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar variant="square" src={URL.createObjectURL(file)} sx={{ width: 50, height: 50 }} />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB (Aguardando Salvar)`} />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary">Nenhuma nova foto na fila de upload.</Typography>
                  )}
                </AccordionDetails>
              </Accordion>

              {/* 3. Adicionar / Gerenciar Imagens Produto Finalizado (stage: 'check-out') */}
              <Accordion sx={{ boxShadow: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 'bold' }}>Imagens do Produto Finalizado</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* Subseção: Fotos já existentes no banco de dados */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Imagens Salvas no Histórico
                  </Typography>
                  {order && order.images_finished && order.images_finished.length > 0 ? (
                    <List sx={{
                      bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #eee', mb: 2
                    }}
                    >
                      {order.images_finished.map((img) => (
                        <ListItem
                          key={`saved-finalized-img-${img.id}`}
                          secondaryAction={!disabled && (
                          <IconButton
                            edge="end"
                            onClick={() => deleteOrderImage(img.id, `saved-finalized-img-${img.id}`)}
                            title="Apagar imagem do servidor"
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar
                              variant="square"
                              src={img.image}
                              sx={{ width: 50, height: 50, cursor: 'pointer' }}
                              onClick={() => window.open(img.image, '_blank')}
                            />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary="Imagem finalizada" secondary="Salva no servidor" />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                      Nenhuma imagem salva para este estágio até o momento.
                    </Typography>
                  )}

                  <Divider sx={{ my: 2 }} />

                  {/* Subseção: Envio de novos arquivos */}
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    Enviar Novas Fotos do Produto Pronto
                  </Typography>

                  {!disabled && (
                  <Button component="label" variant="contained" color="success" sx={{ mb: 2 }}>
                    Selecionar Fotos do Produto Finalizado
                    <input type="file" accept="image/*" multiple hidden onChange={handleFinalizedFilesChange} />
                  </Button>
                  )}

                  {finalizedImages.length > 0 ? (
                    <List sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #ddd' }}>
                      {finalizedImages.map((file, index) => (
                        <ListItem
                          key={`upload-finalized-img-${file.name}-${file.size}`}
                          secondaryAction={!disabled && (
                          <IconButton edge="end" onClick={() => handleRemoveFinalizedImage(index)}>
                            <DeleteIcon color="error" />
                          </IconButton>
                          )}
                        >
                          <ListItemAvatar>
                            <Avatar variant="square" src={URL.createObjectURL(file)} sx={{ width: 50, height: 50 }} />
                          </ListItemAvatar>
                          <ListItemText sx={{ pl: 2 }} primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB (Aguardando Salvar)`} />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <Typography variant="body2" color="textSecondary">Nenhuma nova foto na fila de upload.</Typography>
                  )}
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Box>
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            {!order
              ? (
                <>
                  <Grid
                    item
                    container
                    md={6}
                    lg={6}
                    xs={12}
                  >
                    <>
                      {!productId
                        ? (
                          <Autocomplete
                            id="auto-client"
                            fullWidth
                            options={clientsSearch}
                            onChange={handleClientItemSelecionado}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                {...params}
                                label="Cliente"
                                variant="outlined"
                                error={!!clientValidate.error}
                                helperText={clientValidate.error ? clientValidate.error : ''}
                              />
                            )}
                          />
                        ) : (
                          <>

                            { product && (
                            <TextField
                              fullWidth
                              disabled
                              value={product.client.name}
                            />
                            )}
                          </>
                        )}
                    </>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    lg={6}
                    xs={12}
                  >
                    {!productId
                      ? (
                        <Autocomplete
                          id="auto-product"
                          fullWidth
                          name="productName"
                          options={productsSearch}
                          value={values.productObject}
                          onChange={handleProductItemSelecionado}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              {...params}
                              label="Produtos"
                              variant="outlined"
                              error={!!productValidate}
                              helperText={productValidate || ''}
                            />
                          )}
                        />
                      ) : (
                        <>
                          { product && (
                          <TextField
                            fullWidth
                            disabled
                            value={product.name}
                          />
                          )}
                        </>
                      )}
                  </Grid>
                </>
              )
              : (
                <>
                  <Grid
                    item
                    md={6}
                    lg={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      disabled={disabled}
                      label="Cliente"
                      name="clientName"
                      value={order.client.name}
                      variant="outlined"
                    />
                    <Button onClick={handleSeeClient}>Ver Cliente</Button>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    lg={6}
                    xs={12}
                  >
                    <TextField
                      fullWidth
                      disabled={disabled}
                      label="Produto"
                      name="productName"
                      value={order.product.name}
                      variant="outlined"
                    />
                  </Grid>

                </>
              )}
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Status"
                name="status"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.status}
                variant="outlined"
              >
                <option />
                {Object.entries(status).map((option) => (
                  <option
                    key={option[0]}
                    value={option[0]}
                  >
                    {option[1]}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Técnico"
                name="technician_id"
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
                value={values.technician_id}
                variant="outlined"
              >
                <option />
                {technicians && technicians.data && technicians.data.map((option) => (
                  <option
                    key={option.id}
                    value={option.id}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Número da Ordem de Serviço"
                name="order_number"
                required
                onChange={handleChange}
                value={values.order_number}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              lg={6}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Autorização para Retirada"
                name="authorization_withdrawal"
                onChange={handleChange}
                value={values.authorization_withdrawal}
                variant="outlined"
              />
            </Grid>
            <Grid container spacing={3} item xs={12}>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
                mb={2}
              >
                <TextField
                  fullWidth
                  disabled={disabled}
                  label="Entrada da Order"
                  name="entry_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.entry_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Data Fim Orçamento"
                  name="finalized_budget_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.finalized_budget_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Data Orçamento Aprovado"
                  name="approved_budget_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.approved_budget_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Inicio do Serviço"
                  name="running_service_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.running_service_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
                mt={2}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Serviço Pronto"
                  name="service_completed_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.service_completed_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
                mt={2}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Data Aguardando Cliente"
                  name="awaiting_withdrawal_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.awaiting_withdrawal_date}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                lg={6}
                xs={12}
                mt={2}
              >
                <TextField
                  fullWidth
                  disabled
                  label="Data Order Finalizada"
                  name="finished_order_date"
                  type="datetime-local"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={values.finished_order_date}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {values.status === 'C'
              ? (
                <>
                  <Grid
                    item
                    style={{
                      border: '1px solid #E25141',
                      backgroundColor: '#f3c7cb',
                      borderRadius: 5
                    }}
                    ml={3}
                    mt={3}
                    pb={3}
                    pr={3}
                    xs={12}
                  >
                    <Grid
                      item
                      md={6}
                      lg={6}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        disabled={disabled}
                        label="Motivo do Cancelamento"
                        name="reason_canceled"
                        onChange={handleChange}
                        multiline
                        rows={4}
                        value={values.reason_canceled}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid
                      item
                      md={6}
                      lg={6}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        disabled
                        label="Cancelado do Serviço"
                        name="canceled_date"
                        type="datetime-local"
                        onChange={handleChange}
                        required
                        value={values.canceled_date}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </>
              )
              : <></> }
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Observação"
                name="observation"
                onChange={handleChange}
                multiline
                rows={4}
                value={values.observation}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <TextField
                fullWidth
                disabled={disabled}
                label="Diagnóstico"
                name="diagnosis"
                onChange={handleChange}
                multiline
                rows={4}
                value={values.diagnosis || ''}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Divider />

        {order
          ? (
            <>
              <Grid container style={{ padding: 20 }}>
                <Grid lg={12} md={12} xs={12} container style={{ paddingBottom: 20 }}>
                  <Grid lg={10} md={10} xs={12}>
                    <Typography variant="h1" component="h2">
                      Serviços
                    </Typography>
                  </Grid>
                  <Grid
                    lg={2}
                    md={2}
                    xs={12}
                    textAlign="right"
                  >
                    { order && !order.client.deleted && order.status !== 'CO' && order.status !== 'FO'
                      ? (
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={addService}
                        >
                          <PlusIcon style={{ marginRight: 10 }} />
                          Adicionar
                        </Button>
                      )
                      : <></> }
                  </Grid>
                </Grid>
                <Grid xs={12} style={{ paddingBottom: 20 }}>
                  <OrderServiceListResults services={order.services} exclude={deleteService} edit={editService} reload={reloadData} disabled={disabled} />
                </Grid>
                <Grid lg={6} md={6} xs={12} p={1}>
                  <Box sx={{
                    mb: 2, bgcolor: 'info.main', p: 2, borderRadius: 1, color: 'info.contrastText'
                  }}
                  >
                    <Typography variant="h3" component="h2">
                      {'Total : R$ '}
                      {values.amount_services}
                    </Typography>
                  </Box>
                </Grid>
                <Grid lg={6} md={6} xs={12} p={1}>
                  <Box sx={{
                    mb: 2, bgcolor: 'success.main', p: 2, borderRadius: 1, color: 'success.contrastText'
                  }}
                  >
                    <Typography variant="h3" component="h2">
                      {'Aprovado : R$ '}
                      {values.amount_aproved_services}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </>
          )
          : <></> }

        <Divider />
        <Grid container style={{ padding: 20 }}>
          <Grid xs={12} style={{ paddingBottom: 20 }}>
            <Typography variant="h1" component="h2">
              Financeiro
            </Typography>
          </Grid>
          <Grid xs={12} m={1}>
            <CurrencyFormat
              name="labor"
              label="Valor da Mão de Obra"
              data-test="input-value"
              onChange={handleChange}
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              placeholder="R$ 0,00"
              prefix="R$ "
              value={values.labor}
              fullWidth
              customInput={TextField}
              InputProps={{
                style: { textAlign: 'right' },
              }}
              variant="outlined"
              margin="normal"
            />
          </Grid>
          <Grid xs={12} m={1}>
            <CurrencyFormat
              label="Valor Aprovado"
              data-test="input-value"
              onChange={handleChange}
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              placeholder="R$ 0,00"
              prefix="R$ "
              value={values.amount_aproved_services}
              fullWidth
              disabled
              customInput={TextField}
              InputProps={{
                style: { textAlign: 'right' },
              }}
              variant="outlined"
              margin="normal"
            />
          </Grid>
          <Grid xs={12} m={1}>
            <CurrencyFormat
              label="Valor Total da Ordem"
              data-test="input-value"
              onChange={handleChange}
              decimalSeparator=","
              thousandSeparator="."
              decimalScale={2}
              fixedDecimalScale
              placeholder="R$ 0,00"
              prefix="R$ "
              value={values.amount_order}
              fullWidth
              disabled
              customInput={TextField}
              InputProps={{
                style: { textAlign: 'right' },
              }}
              variant="outlined"
              margin="normal"
            />
          </Grid>
        </Grid>
        <Divider />
        {
          !disabled
            ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2
                }}
              >
                <Grid container spacing={3}>
                  {bottonsFunction()}
                </Grid>
              </Box>
            )
            : <></>
        }
        <ServiceModal modal={serviceModal} />
        <CancelOrderModal modal={cancelOrderModal} />
        <ConfirmModal modal={confirmOrderModal} />
        <DeleteModal modal={deleteImageModal} />
      </Card>
    </form>
  );
};

OrderProfileDetails.propTypes = {
  config: PropTypes.object,
  productId: PropTypes.number,
  order: PropTypes.object,
  products: PropTypes.object,
  status: PropTypes.object,
  technicians: PropTypes.object,
  updateform: PropTypes.func.isRequired,
  deleteImage: PropTypes.func.isRequired,
  saveform: PropTypes.func.isRequired,
  deleteService: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  getService: PropTypes.func.isRequired,
  saveService: PropTypes.func.isRequired,
  updateService: PropTypes.func.isRequired,
  setChangeStatusOrder: PropTypes.func.isRequired,
  setCancel: PropTypes.func.isRequired,
  clients: PropTypes.object,
  getProductsByClient: PropTypes.func.isRequired,
  getProduct: PropTypes.func,
  product: PropTypes.object
};

export default OrderProfileDetails;
